export default function ValidadorFirmaButton({ base64, filename = 'documento.pdf' }) {
  const descargarPDF = () => {
    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al descargar el PDF:', error);
    }
  };

  const irAlValidador = () => {
    window.open('https://validadordefirmas.gob.ar/upload', '_blank');
  };

  return (
    <div className="text-center mt-4 d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3 flex-wrap">
      {/* Botón de descarga */}
      <button
        onClick={descargarPDF}
        className="px-4 py-2 fw-bold w-auto"
        style={{
          backgroundColor: '#28a745',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          fontSize: '1rem',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s ease',
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = '#218838')}
        onMouseOut={(e) => (e.target.style.backgroundColor = '#28a745')}
      >
        Descargar PDF
      </button>

      {/* Botón validador */}
      <button
        onClick={irAlValidador}
        className="px-4 py-2 fw-bold w-auto"
        style={{
          backgroundColor: '#3C8DBC',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          fontSize: '1rem',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s ease',
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = '#357aa8')}
        onMouseOut={(e) => (e.target.style.backgroundColor = '#3C8DBC')}
      >
        Ir al Validador
      </button>
    </div>
  );
}
